export default "__VITE_ASSET__BOvB9eA$__"